import { render } from "./MaternalSafety.vue?vue&type=template&id=4d3fd140&scoped=true"
import script from "./MaternalSafety.vue?vue&type=script&lang=js"
export * from "./MaternalSafety.vue?vue&type=script&lang=js"

import "./MaternalSafety.vue?vue&type=style&index=0&id=4d3fd140&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3fd140"]])

export default __exports__